module.exports = __webpack_public_path__ + "static/splash-d1f4ef4e0bb197b06d25a885140d23a1.jpg";